module.exports = __webpack_public_path__ + "static/img/trip.f9bf26af.png";